import SubmitDataBuilder from "../../builders/campaign/SubmitDataBuilder";

export default class SubmitDataBuilderFactory {

  static create(): SubmitDataBuilder {
    return new SubmitDataBuilder();
  }

}
